import { render, staticRenderFns } from "./LevelContent.vue?vue&type=template&id=3031bdb5&scoped=true&"
import script from "./LevelContent.vue?vue&type=script&lang=js&"
export * from "./LevelContent.vue?vue&type=script&lang=js&"
import style0 from "./LevelContent.vue?vue&type=style&index=0&id=3031bdb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3031bdb5",
  null
  
)

export default component.exports